import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import gettext from '@sdk/lang/gettext';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import { FooterRegularButtonWrapper } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';

const PROGRESS_BUTTON_HEIGHT = 38;

type Props = {
  onApprove: () => Promise<void>;
};
const ApproveTimesheetFooterButton = ({ onApprove }: Props) => (
  <FooterRegularButtonWrapper mLeft={10}>
    <ProgressButton
      onClick={onApprove}
      buttonType={ButtonType.success}
      height={PROGRESS_BUTTON_HEIGHT}>
      {gettext('Approve')}
    </ProgressButton>
  </FooterRegularButtonWrapper>
);

export default ApproveTimesheetFooterButton;
